module.exports = __webpack_public_path__ + "img/victor.29b59ad3.jpg";